import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const redirectPath = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? '/mindex' : '/index'
    // const redirectPath = "/index"
const isMaintenance = String(process.env.VUE_APP_MAINTENANCE || 'false') === 'true'
const upgradingRoute = {
        path: '/upgrading',
        name: 'ServiceUpgrading',
        component: () =>
            import ('@/views/ServiceUpgrading.vue')
    }

const maintenanceRoutes = [{
        path: '/',
        redirect: '/upgrading',
    },
    upgradingRoute,
    {
        path: '*',
        redirect: '/upgrading',
    }
]

const normalRoutes = [{
        path: '/',
        redirect: redirectPath,
    },
    upgradingRoute,
    {
        path: '/index',
        name: 'PCIndex',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC/Index.vue')
    },
    {
        path: '/product',
        name: 'PCProduct',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC/Product.vue'),
        redirect: "/product/list/rangcha",
        children: [{
                path: '/product/list/rangcha',
                name: 'PCRangchaList',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC/RangchaList.vue'),
            },
            {
                path: '/product/list/tasantea',
                name: 'PCTasnateaList',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC/TasnateaList.vue'),
            }, {
                path: '/product/rangcha/detail',
                name: 'PCRangchaProductDetail',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC/RangchaProductDetail.vue'),
            },
            {
                path: '/product/tasantea/detail',
                name: 'PCTasanteaProductDetail',
                meta: { type: 'pc' },
                component: () =>
                    import ('@/views/PC/TasanteaProductDetail.vue'),
            },

        ]
    },
    {
        path: '/company',
        name: 'PCCompany',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC/Company.vue')
    },
    {
        path: '/news',
        name: 'PCNews',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC/News.vue')
    },
    {
        path: '/pc/test',
        name: 'Test',
        meta: { type: 'pc' },
        component: () =>
            import ('@/views/PC/Test.vue'),
    },
    {
        path: '/mindex',
        name: 'MobileIndex',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/Index.vue')
    },
    {
        path: '/mrangcha/list',
        name: 'MobileRangchaProductList',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/RangchaProductList.vue')
    },
    {
        path: '/mrangcha/detail',
        name: 'MobileRangchaProductDetail',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/RangchaProductDetail.vue')
    },
    {
        path: '/mtasantea/list',
        name: 'MobileTasanteaProductList',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/TasanteaProductList.vue')
    },
    {
        path: '/mtasantea/detail',
        name: 'MobileTasanteaProductDetail',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/TasanteaProductDetail.vue')
    },
    {
        path: '/mcompany',
        name: 'MobileCompanyIntroduce',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/CompanyIntroduce.vue')
    },
    {
        path: '/mnews',
        name: 'MobileCompanyNews',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/CompanyNews.vue')
    },
    {
        path: '/mtest',
        name: 'MobileTest',
        meta: { type: 'mobile' },
        component: () =>
            import ('@/views/Mobile/MTest.vue')
    },

]

const routes = isMaintenance ? maintenanceRoutes : normalRoutes

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
        if (isMaintenance && to.path !== '/upgrading') return next('/upgrading')
        if (to.meta.type == "mobile" && redirectPath == "/index") return next("/index")
        if (to.meta.type == "pc" && redirectPath == "/mindex") return next("/mindex")
        return next()
    })
    // 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}


export default router
